import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html'
})
export class DatePickerComponent implements OnInit {
  public taskForm: FormGroup;
  minDate;
  model;

  ngOnInit() {
    const today = new Date;
    this.minDate = { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() };
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/date-picker/date-picker.component.ts